import { apiGetMe } from '../../common/api/profile'
import { apiDeleteOauthIdentity } from '../../common/api/authentication'

const fetchProviders = () => ({
  requestPrefix: 'PROVIDERS:FETCH',
  request: () =>
    apiGetMe({
      include: 'account.oauth_identities,account.oauth_identity.provider'
    })
})

const removeProvider = id => ({
  requestPrefix: 'PROVIDERS:REMOVE',
  params: { id },
  request: () => apiDeleteOauthIdentity(id)
})

const connectProvider = connectFn => ({
  requestPrefix: 'PROVIDERS:CONNECT',
  request: () => connectFn()
})

export { fetchProviders, removeProvider, connectProvider }
